import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Spinner } from 'components/Spinner/Spinner';

export default React.memo(() => {
  const navigate = useNavigate();
  const { user, isInitialized, authLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user?._id) navigate('/tickets');
  }, [user, navigate]);

  return <>{(!isInitialized || authLoading) && <Spinner />}</>;
});
